import { cn } from '@/utils/cn'

interface StepHeaderProps {
  title: string
  description: string
  className?: string
}

/**
 * Reusable header component for wizard steps.
 * Displays a centered title and description.
 */
export function StepHeader({ title, description, className }: StepHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-1 items-center w-full', className)}>
      <h2 className="font-bold leading-[28px] text-[#1C1C1C] text-[24px]">
        {title}
      </h2>
      <p className="font-normal leading-[24px] text-[16px] text-[#556374]">
        {description}
      </p>
    </div>
  )
}
